// extracted by mini-css-extract-plugin
export default {"mainImg":"OwnersImg_mainImg__0s2-6"};